import { createContext, useContext, useEffect, useState, type ReactNode } from 'react';
import { blocksOperations, type Job } from '@mcpanel/core';
import { api } from '../api/client';
import { jobKindLabel } from '../format';
import { errorMessage, useApp } from '../app-context';

export const OperationBlockedContext = createContext(false);
export function useActiveOperation(serverId: string) {
  const [job, setJob] = useState<Job>();
  const [loading, setLoading] = useState(true);
  const { notify } = useApp();
  useEffect(() => {
    let closed = false;
    setLoading(true);
    const load = async () => {
      try {
        const jobs = await api.jobs({ serverId });
        if (!closed) {
          setJob(jobs.find(blocksOperations));
          setLoading(false);
        }
      } catch (error) {
        if (!closed) notify(errorMessage(error), true);
      }
    };
    void load();
    const stop = api.openConsole(serverId, (event) => {
      if (event.type !== 'operation') return;
      setLoading(false);
      if (blocksOperations(event.job)) setJob(event.job);
      else setJob((current) => (current?.id === event.job.id ? undefined : current));
    });
    const timer = setInterval(() => void load(), 15000);
    return () => {
      closed = true;
      clearInterval(timer);
      stop();
    };
  }, [serverId]);
  return { job, loading };
}
export function OperationBoundary({ serverId, children }: { serverId: string; children: ReactNode }) {
  const { job, loading } = useActiveOperation(serverId);
  const parentBlocked = useContext(OperationBlockedContext);
  const blocked = parentBlocked || loading || Boolean(job);
  return (
    <div className="stack">
      {job && (
        <div className="alert info">
          {job.requestedBy} の {jobKindLabel[job.kind] ?? job.kind} を実行中
        </div>
      )}
      <fieldset disabled={blocked} style={{ border: 0, padding: 0, margin: 0, minWidth: 0 }}>
        <OperationBlockedContext.Provider value={blocked}>{children}</OperationBlockedContext.Provider>
      </fieldset>
    </div>
  );
}
